/* eslint-disable */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Image from '../images/full.jpg';
import Contour from '../images/vectors/contour-fill.png';
import ContourMobile from '../images/vectors/contour-mobile.png';
import Media from 'react-media';
import '../css/Banner.css';

const useStyles = makeStyles((theme) => ({
  backgroundMobile: {
    // maxHeight: 450,
    position: 'absolute',
    // width: '100%',
    marginLeft: '-200px',
    height: 500,
    background:
      'linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(61,61,61,1) 100%)',
  },
  root: {
    position: 'relative',
    marginLeft: 'auto',
    backgroundColor: theme.palette.grey[800],
    backgroundImage: `url(${Image})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: 500,
    width: '100%',
    transition: 'transform 0.4s',
    '&:hover': {
      transform: 'scale(1.005)',
    },
  },
  rootMobile: {
    position: 'relative',
    marginLeft: 'auto',
    backgroundColor: theme.palette.grey[800],
    backgroundImage: `url(${Image})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: 300,
  },
  overlay: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundImage: `url(${Contour})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    opacity: '0.7',
    maxWidth: '100%',
    padding: '1vh',
  },
  overlayMobile: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    width: '102%',
    height: '100%',
    backgroundImage: `url(${ContourMobile})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    opacity: '0.7',
    padding: '1vh',
  },
  bigtabMobile: {
    position: 'absolute',
    marginLeft: '1.5%',
    marginRight: '0%',
    width: '90%',
    height: '70px',
    marginTop: '-65px',
    background: 'white',
  },
  bigtab: {
    position: 'absolute',
    width: '300px',
    height: '100px',
    marginTop: '-95px',
    marginLeft: '80px',
    background: 'white',
    paddingLeft: '40px',
    backgroundColor: '#FAFAFA',
  },
  topStyleMobile: {
    marginLeft: 'auto',
    marginRight: '40px',
    color: '#27617E',
    marginTop: '5rem',
    marginBottom: '-2rem',
    fontWeight: 'normal',
    fontSize: '2rem',
  },
  midStyleMobile: {
    marginLeft: 'auto',
    marginRight: '40px',
    marginBottom: '-3vw',
    color: '#27617E',
    fontWeight: 'bold',
    fontSize: '2.5rem',
  },
  bottomStyleMobile: {
    marginLeft: 'auto',
    marginRight: '40px',
    marginBottom: '-1vw',
    color: '#27617E',
    marginTop: '3vw',
    fontWeight: 'normal',
    fontSize: '2rem',
  },
  topStyle: {
    marginLeft: 'auto',
    marginRight: '40px',
    color: '#27617E',
    marginTop: '5rem',
    marginBottom: '-2rem',
    fontWeight: 'normal',
    fontSize: '3rem',
  },
  midStyle: {
    marginLeft: 'auto',
    marginRight: '40px',
    marginBottom: '-3vw',
    color: '#27617E',
    fontWeight: 'bold',
    fontSize: '3.5rem',
  },
  bottomStyle: {
    marginLeft: 'auto',
    marginRight: '40px',
    marginBottom: '-1vw',
    color: '#27617E',
    marginTop: '3vw',
    fontWeight: 'normal',
    fontSize: '3rem',
  },
  text: {
    marginTop: '3rem',
    marginLeft: 'auto',
    marginRight: '40px',
    color: '#27617E',
    fontSize: '20px',
    textAlign: 'right',
    float: 'right',
    width: '540px',
  },
  exploreStyle: {
    position: 'absolute',
    backgroundColor: '#27617E',
    marginLeft: '78%',
    marginTop: '15%',
    margin: '0 auto',
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'scale(1.1)',
    },
    zIndex: 1,
  },
}));

/**
 * The welcome picture of the banner component
 * @component Banner
 * @return {Component} BannerMobile component
 */
function WelcomeMobile() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.backgroundMobile}></div>
      <Grid container className={classes.rootMobile}>
        <div className={classes.overlayMobile} href="#">
          <br />
          <br />
          <h2
            className={classes.topStyleMobile}
            style={{marginRight: '20px', marginTop: '60px'}}
          >
            ON THE
          </h2>
          <h1 className={classes.midStyleMobile} style={{marginRight: '20px'}}>
            LEADING EDGE
          </h1>
          <h2
            className={classes.bottomStyleMobile}
            style={{marginRight: '20px'}}
          >
            OF BIOTECH.
          </h2>
          <br />
        </div>
      </Grid>
      {/* <div className={classes.bigtabMobile}>
        <p style={{color: '#27617E', marginTop: '10px',
          textAlign: 'center', fontSize: '12px'}}>March 2021</p>
        <h3 style={{textAlign: 'center', marginTop: '-10px'}}>Featured Articles</h3>
      </div> */}
    </div>
  );
}

/**
 * The welcome picture of the banner component
 * @component Welcome
 * @return {Component} Welcome component
 */
function Welcome() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className="banner-background" />
      <Grid container className={classes.root}>
        <div className={classes.overlay} href="#">
          <br />
          <br />
          <h2 className={classes.topStyle}>ON THE</h2>
          <h1 className={classes.midStyle}>LEADING EDGE</h1>
          <h2 className={classes.bottomStyle}>OF BIOTECH.</h2>
          <br />
          <p className={classes.text}>
            Today more than ever, America's toughest challenges require the
            focus and determination of skilled experts in, and beyond the
            biotechnology industry.
          </p>
        </div>
      </Grid>
      {/* <div className={classes.bigtab}>
        <h3 style={{color: '#27617E', marginTop: '15px',
          marginLeft: '-5px'}}>March 2021</h3>
        <h1 style={{marginTop: '-15px',
          marginLeft: '-5px'}}>Featured Articles</h1>
      </div> */}
    </div>
  );
}

/**
 * The banner section at the top of home page
 * @component Banner
 * @return {Component} Banner component
 */
export default function Banner() {
  return (
    <Media query="(max-width: 800px)">
      {(matches) => {
        return matches ? (
          <div>
            <WelcomeMobile />
          </div>
        ) : (
          <div>
            <Welcome />
          </div>
        );
      }}
    </Media>
  );
}
